import { Flex, Image, Paragraph, Stack, Strong } from '@customerio/pluma-components/react';
import notion from '@/assets/images/billing-brands/notion.svg';
import indeed from '@/assets/images/billing-brands/indeed.svg';
import mixpanel from '@/assets/images/billing-brands/mixpanel.svg';
import typeform from '@/assets/images/billing-brands/typeform.svg';
import mapbox from '@/assets/images/billing-brands/mapbox.svg';
import buffer from '@/assets/images/billing-brands/buffer.svg';
import angi from '@/assets/images/billing-brands/angi.svg';

const BRAND_LOGOS = [notion, indeed, mixpanel, typeform, mapbox, buffer, angi];

/** The "trusted by 7,600+ brands" social-proof strip shown beneath the plan grid. */
export function HighlightedBrands() {
  return (
    <Stack gap="300" textAlign="center" mx="auto" style={{ width: '70%' }}>
      <Paragraph color="secondary">
        <Strong>Trusted by 7,600+ brands around the world</Strong> to send data powered communication every day
      </Paragraph>
      <Flex justifyContent="space-between" alignItems="center">
        {BRAND_LOGOS.map((src) => (
          <Image key={src} src={src} alt="" aria-hidden="true" />
        ))}
      </Flex>
    </Stack>
  );
}
